module.exports = ".item-value {\n  color: darkblue;\n  font-size: larger; }\n"